__turbopack_context__.v({
  "container": "AjTMRq_container",
  "flag": "AjTMRq_flag",
  "flagEndIcon": "AjTMRq_flagEndIcon",
  "indicatorIcon": "AjTMRq_indicatorIcon",
});
